export enum TaskCode {
  PreviewDocuments = "PreviewDocuments",
  SigningRoomCheckIn = "SigningRoomCheckIn",
  CompletedPackageDownload = "CompletedPackageDownload",
  JoinSigning = "JoinSigning"
}
